<template>
  <div class="content" @click="onItemClick">
    <div class="left-part">
      <div
        v-if="showQuantity"
        class="quantity mr-3 tp-text-body-white"
        :class="{ delivered: isPaid, selected: selected }"
      >
        1
      </div>
      <div class="d-flex align-start flex-column">
        <span
          class="tp-text-subtitle-semibold text--grey"
          :class="{ 'grey--text': selected }"
          >{{ $t(name) }}</span
        >
        <div
          v-if="!hideModifiers && visibleModifiers.length"
          class="order-item-modifiers"
        >
          <div
            v-for="(modifier, key) in visibleModifiers"
            :key="key"
            class="tp-text-body grey--text text--darken-2"
          >
            {{ $t(modifier.name) }}
            <span v-if="modifier.price !== undefined && modifier.price !== null">
              ({{ getModifierFormattedPrice(modifier.price) }})
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="right-part">
      <v-fade-transition>
        <div
          v-if="strikethroughPrice"
          class="tp-text-subtitle-normal red--text text--darken-1 ml-2"
          :class="{ 'grey--text': selected }"
        >
          {{ formattedPrice }}
        </div>
      </v-fade-transition>
      <div
        class="tp-text-subtitle-normal ml-2"
        :class="{
          'grey--text': selected,
          'text-decoration-line-through': strikethroughPrice,
        }"
      >
        {{ formattedStrikethroughPrice }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemKey: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    completed: {
      type: Boolean,
      required: false,
      default: false,
    },
    price: {
      type: Number,
      default: null,
      required: false,
    },
    strikethroughPrice: {
      type: Number,
      default: null,
      required: false,
    },
    quantity: {
      type: Number,
      default: null,
      required: false,
    },
    modifiers: {
      type: Array,
      default: () => [],
      required: false,
    },
    isPaid: {
      type: Boolean,
      default: null,
      required: false,
    },
    showQuantity: {
      type: Boolean,
      default: true,
      required: false,
    },
    selected: {
      type: Boolean,
      default: false,
      required: false,
    },
    hideModifiers: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    visibleModifiers() {
      return this.modifiers.filter(modifier => modifier?.price > 0);
    },
    priceWithModifiers() {
      let price = 0;
      price += this.price;

      this.modifiers.forEach(modifier => {
        price += modifier.price;
      });

      return price;
    },
    formattedPrice() {
      return this.$store.getters.getFormattedPrice(this.priceWithModifiers);
    },
    formattedStrikethroughPrice() {
      if (this.strikethroughPrice) {
        return this.$store.getters.getFormattedPrice(this.strikethroughPrice);
      }
      return this.formattedPrice;
    },
  },
  methods: {
    getModifierFormattedPrice(price) {
      return this.$store.getters.getFormattedPrice(Number(price));
    },
    onItemClick() {
      this.$emit('click', this.itemKey);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  .left-part {
    display: flex;
    flex-direction: row;
    flex: 0.8;
  }
  .right-part {
    display: flex;
    flex: 0.2;
    justify-content: flex-end;
  }
}
.quantity {
  width: 20px;
  min-width: 20px;
  height: 20px;
  border-radius: 3px;
  background-color: $color-black;
  color: $color-white;
  display: flex;
  justify-content: center;
  align-items: center;

  &.delivered {
    background-color: $color-success;
  }

  &.selected {
    background-color: $color-gray-500;
  }
}
</style>
